<!-- prettier-ignore -->

@if(showBanner()){
    <div [@slideInOutFromBottom]="showBanner() && !isMobile()" [@slideInOutFromTop]="showBanner() && isMobile()" class="banner-install-app" >
        <div class="banner-install-app__wrapper">
            <span 
              class="ci-heading-h5-s-bold" 
              (click)="addAppToDesktop()">
              {{'Añadir la app al escritorio' | translate}}
            </span>
            <ion-icon (click)="disableBanner()" name="close-circle-outline"></ion-icon>
        </div>
    </div>
}

